import React, { Dispatch, Fragment, SetStateAction, useState } from "react";

import { useCompleteConversation } from "../../../hooks/mbts-ux";

import { TextInput } from "../../shared/Inputs";

interface IChatIntermediateProceedWindowProps {
    visible: boolean;
    setVisible: Dispatch<SetStateAction<boolean>>;
    recommMsgs: number;
    conversationId: string;
    scenarioId: string | null;
    nextOperation: 'next-persona' | 'analysis' | null;
    nextPersonaDetails: { personaId: string } | null;
};
export const ChatIntermediateProceedWindow = (props: IChatIntermediateProceedWindowProps) => {
    const { visible, setVisible, recommMsgs, conversationId, scenarioId, nextOperation, nextPersonaDetails } = props;

    const [txt, setTxt] = useState('');
    const [isProcessing, setIsProcessing] = useState<boolean>(false);

    const { mutate: completeConversation } = useCompleteConversation();

    const handleNext = () => {
        if (!scenarioId || !nextOperation || txt !== "Proceed") return;

        completeConversation({
            conversationId,
            scenarioId,
            setIsProcessing,
            nextOperation,
            nextPersonaDetails,
        });
    };

    return (
        <div className={`mbts_chat__conversation_intermediate_proceed_window ${visible ? 'mbts_chat__conversation_intermediate_proceed_window--visible' : ''}`}>
            <div className='card card--md card--radius-md mbts_chat__conversation_intermediate_proceed_window__content'>
                <p className='text-2xl text-bold color--primary text-center mb-md'>
                    Do you want to continue?
                </p>
                <p className='color--txt-muted text-center mb-2xl'>
                    We recommend completing at least {recommMsgs} interactions before proceeding.
                </p>
                <p className='text-sm mb-xs color--text-secondary'>
                    Please type <strong>Proceed</strong> to enable the button.
                </p>
                <TextInput
                    type="text"
                    placeholder='Type "Proceed" to continue'
                    value={txt}
                    onChange={e => setTxt(e.target.value)}
                />
                <div className='mbts_chat__conversation_intermediate_proceed_window__actions'>
                    <button
                        className='btn btn--fluid btn--md btn--radius-md btn--primary'
                        onClick={handleNext}
                        disabled={txt !== "Proceed"}
                    >
                        {isProcessing
                            ? <span className='btn-loader' />
                            : <Fragment>
                                {nextOperation === 'analysis' ? <span>Go&nbsp;to&nbsp;Analysis</span> : !!nextPersonaDetails ? <span>Next&nbsp;Persona</span> : <span>Go&nbsp;to&nbsp;Overview</span>}
                            </Fragment>
                        }
                    </button>
                    <button
                        className='btn btn--fluid btn--md btn--radius-md btn--secondary'
                        onClick={() => setVisible(false)}
                    >
                        Discard
                    </button>
                </div>
            </div>
        </div>
    );
};